import React, { FC, useMemo } from 'react'
import Error from '@mui/icons-material/Error'
import NewLayout from './components/NewLayout'
import { humanize, toSentence } from 'utils/formatting'
import CoreButton from 'components/Core/CoreButton'

interface BlockedProps {
  projectTypes: string[]
}

const Blocked: FC<BlockedProps> = ({ projectTypes }) => {
  const friendlyProjectTypes = useMemo(() => {
    return projectTypes.map(
      (projectType) =>
        ({
          adus: 'ADUs',
          landscaping: 'landscaping',
          hardscaping: 'hardscaping',
          kitchen_or_bathroom: 'kitchen/bathroom remodels',
        })[projectType] || `${humanize(projectType).toLowerCase()}s`
    )
  }, [projectTypes])

  return (
    <NewLayout.Outer>
      <NewLayout.Inner size="xl">
        <div className="tw:flex tw:flex-col tw:items-center tw:gap-6">
          <div className="tw:rounded-full tw:p-6 tw:bg-yellow-100">
            <Error className="tw:!size-12 tw:text-yellow-600" />
          </div>
          <div className="tw:flex tw:flex-col tw:items-center">
            <p className="tw:text-lg tw:text-center">
              {`You need at least 2 project examples in your business profile for ${toSentence(friendlyProjectTypes)} to be eligible for this site visit. Please update your profile and revisit this scheduling link once ready.`}
            </p>
          </div>
          <a href="/vendors/profile" className="tw:w-full">
            <CoreButton size="xl" className="tw:w-full" text="Visit business profile" />
          </a>
        </div>
      </NewLayout.Inner>
    </NewLayout.Outer>
  )
}

export default Blocked
